<kilowant-header [isBuyer]="true" title="Place Order"></kilowant-header>
<div class="wrapperMain mainAccountDetailsMain accountDetails">
    <div class="form buyer mt-50">
          <kilowant-buy-offer-edit (cancelled)="cancel()" (finished)="finish()"></kilowant-buy-offer-edit>
    </div>
</div>